import { useBackend } from "../../services";

export const useGetResourceLimits = () => {
  const { get } = useBackend();
  const getResourceLimits = async () => get("user/limits");
  return { getResourceLimits };
};
